import { useEffect, useState } from 'react';

// ** Hooks
import { useCurrentUser } from '@erikdakoda/ui/hooks/useCurrentUser';
import { useUpdateUser } from '@erikdakoda/database/hooks/user';

// ** Capacitor
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { useException } from '@erikdakoda/ui/hooks/useException';

type NotificationsProps = {
  /** Unused — renders no DOM. Accepted so callers can mark it as a guard's root branch for tooling. */
  className?: string;
};

export default function Notifications({ className: _className }: NotificationsProps = {}) {
  'use memo';

  const { user } = useCurrentUser();
  const updateUser = useUpdateUser().mutateAsync;
  const exception = useException();

  const [isRegistered, setIsRegistered] = useState(false);

  const addListeners = async () => {
    await PushNotifications.addListener('registration', async (token) => {
      if (user) {
        try {
          await updateUser({ where: { id: user.id }, data: { iosPushToken: token.value } });
        } catch (err: unknown) {
          exception(err, 'Error updating user push notification token');
        }
      }
    });

    await PushNotifications.addListener('registrationError', (err) => {
      exception(err, 'Error registering push notifications');
    });
  };

  const registerNotifications = async () => {
    let permStatus = await PushNotifications.checkPermissions();

    if (permStatus.receive === 'prompt') {
      permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive !== 'granted') {
      exception(new Error('User denied push notification permissions'));
    }

    await PushNotifications.register();

    setIsRegistered(true);
  };

  /* const getDeliveredNotifications = async () => {
    const notificationList = await PushNotifications.getDeliveredNotifications();
    console.log('delivered notifications', notificationList);
  }; */

  useEffect(() => {
    if (user) {
      if (Capacitor.isNativePlatform() && !isRegistered) {
        addListeners().then(registerNotifications);
      }
    }
  }, [user]);

  return null;
}
